var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { GFIDProvider, getSocialLoginProviderDisplayName } from "healthex-common/healthcareorganization.dtos";
import { LoginSource } from "healthex-common/heap.dtos";
import { computed, observable } from "mobx";
import { getObservableT } from "../Infra/i18next";
import { ClearAuthState } from "../Infra/Persistence";
import { getJWTPayload } from "healthex-common/utils";
const t = getObservableT("patients");
export class AccountLinkingViewModel {
    constructor(container) {
        this.isSandboxLogin = false;
        this.clearAuthManager = container.clearAuthManager;
        this.persistence = container.persistence;
        this.socialLoginAuthManager = container.socialLoginAuthManager;
        this.isSandboxLogin = this.persistence.isSandboxLogin();
    }
    get title() {
        return t("Verify your identity");
    }
    get requiredProviders() {
        var _a, _b;
        return (_b = (_a = this.socialLoginAuthManager.getAccountLinkingData()) === null || _a === void 0 ? void 0 : _a.requiredProviders) !== null && _b !== void 0 ? _b : [];
    }
    get canVerifyWithClear() {
        return this.requiredProviders.length === 0 || this.requiredProviders.includes(GFIDProvider.CLEAR);
    }
    get establishedProvider() {
        if (this.canVerifyWithClear || this.requiredProviders.length !== 1)
            return null;
        const provider = this.requiredProviders[0];
        const isLaunchable = provider === GFIDProvider.GOOGLE || provider === GFIDProvider.MICROSOFT || provider === GFIDProvider.APPLE;
        return isLaunchable ? provider : null;
    }
    get subtitle() {
        var _a;
        const gfidProvider = (_a = this.socialLoginAuthManager.getAccountLinkingData()) === null || _a === void 0 ? void 0 : _a.gfidProvider;
        const providerName = gfidProvider ? getSocialLoginProviderDisplayName(gfidProvider) : "";
        if (this.canVerifyWithClear) {
            return t("Your account was created using CLEAR. To continue with {{providerName}}, we need to verify it's you.", {
                providerName,
            });
        }
        const establishedWith = this.requiredProviders.map((provider) => getSocialLoginProviderDisplayName(provider)).join(", ");
        return t("Your account was created using {{establishedWith}}. Please sign in that way to continue.", { establishedWith });
    }
    get buttonLabel() {
        if (this.canVerifyWithClear)
            return t("Verify with CLEAR");
        const provider = this.establishedProvider;
        if (!provider)
            return t("Choose how to sign in");
        return t("Sign in with {{establishedWith}}", { establishedWith: getSocialLoginProviderDisplayName(provider) });
    }
    get isLoading() {
        return this.clearAuthManager.state === ClearAuthState.IN_PROGRESS;
    }
    get flipLongPressLoginButton() {
        return this.isSandboxLogin;
    }
    async verifyWithClear(sandboxMode) {
        var _a, _b;
        if (!this.canVerifyWithClear) {
            this.socialLoginAuthManager.resetAuth();
            return;
        }
        this.persistence.setSandboxLogin(sandboxMode);
        const linkingToken = (_a = this.persistence.getAccountLinkingData()) === null || _a === void 0 ? void 0 : _a.linkingToken;
        const linkingEmail = linkingToken ? (_b = getJWTPayload(linkingToken).email) !== null && _b !== void 0 ? _b : null : null;
        try {
            await this.clearAuthManager.redirectToClearLoginPage(window.location.hash, LoginSource.ACCOUNT_LINKING, undefined, false, sandboxMode, linkingEmail);
        }
        catch (e) {
            console.error("Failed to redirect to CLEAR login", e);
        }
    }
}
__decorate([
    observable
], AccountLinkingViewModel.prototype, "isSandboxLogin", void 0);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "title", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "requiredProviders", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "canVerifyWithClear", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "establishedProvider", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "subtitle", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "buttonLabel", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "isLoading", null);
__decorate([
    computed
], AccountLinkingViewModel.prototype, "flipLongPressLoginButton", null);
